import React from "react";
import cssExports from "theme/styles/main.module.scss";
//#region types
import { DetailsTableProps } from "models/propTypes/listPropTypes";
//#endregion
//#region components
import DetailsTableView from "./detailsTableView";
//#endregion
import clsx from "clsx";

const DetailsTableViewSmall: React.FC<DetailsTableProps> = (props) => {
  return (
    <DetailsTableView
      detailsList={props.detailsList}
      buttonText={props.buttonText}
      buttonOnClick={props.buttonOnClick}
      hideButton={props.hideButton}
      className={clsx(cssExports.detailsTableViewSmall, props.className)}
      valueAlignment={props.valueAlignment}
    ></DetailsTableView>
  );
};

export default DetailsTableViewSmall;
